// extracted by mini-css-extract-plugin
export default {"container":"PatientPharmacyPage_container__REST-","bottomRow":"PatientPharmacyPage_bottomRow__T-rXb","prescribeButton":"PatientPharmacyPage_prescribeButton__HrgbE"};